export default {
  defaultVariableText: 'Выберите переменную',
  parameter: 'переменную',
  emptyRegexp: 'Заполните значение n',
  emptyVariableText: 'Строка символов',
};
